export default __webpack_public_path__ + "58a352c38898e6f7281bcc5cb04fdd16.png";